<template>
  <v-container>
    <v-dialog v-model="dialog" persistent max-width="900px">
      <v-card v-if="selectedElementToUpdate">
        <v-toolbar dense>
          <v-toolbar-title>{{ ModalTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title class="justify-center">
          {{ selectedElementToUpdate.sigma }} - {{ selectedElementToUpdate.name }} - VL {{ selectedElementToUpdate.logisticVariantCode }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th></th>
                    <th class="text-center">
                      Qté en stock
                    </th>
                    <th class="text-center">
                      Qté bloquée
                    </th>
                    <th class="text-center">
                      <div v-if="blockingType === 'B'">
                        Qté à bloquer
                      </div>
                      <div v-else>
                        Qté à débloquer
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Colis</td>
                    <td class="text-right">
                      {{ selectedElementToUpdate.parcelTotalNumber }}
                    </td>
                    <td class="text-right">
                      {{ selectedElementToUpdate.blockedParcelTotalNumber }}
                    </td>
                    <td class="text-right">
                      <v-text-field dense type="number" v-model="colSai" solo @blur="calculateValue" hide-details></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>UVC</td>
                    <td class="text-right">
                      {{ selectedElementToUpdate.csuTotalNumber }}
                    </td>
                    <td class="text-right">
                      {{ selectedElementToUpdate.blockedCSUTotalNumber }}
                    </td>
                    <td class="text-right">
                      <v-text-field dense type="number" v-model="uvcSai" solo hide-details></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td>Poids net</td>
                    <td class="text-right">
                      {{ selectedElementToUpdate.netWeightTotal }}
                    </td>
                    <td class="text-right">
                      {{ selectedElementToUpdate.blockedNetWeightTotal }}
                    </td>
                    <td class="text-right">
                      <v-text-field dense type="decimal" v-model="netSai" solo hide-details></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text outlined @click="validate_VL" :disabled="canValidateVl">
            Valider
          </v-btn>
          <v-btn text outlined @click="cancel">
            Annuler
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="errorNotif" color="error darken-1" :multi-line="true" :right="true" timeout="-1" :vertical="true" :top="true">
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="errorNotif = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
      v-model="successNotif"
      color="success darken-1"
      :multi-line="true"
      :right="true"
      timeout="1000"
      :top="true"
      :vertical="true"
    >
      {{ successMessage }}
    </v-snackbar>
  </v-container>
</template>

<script type="text/javascript">
import moment from "moment";
import "moment/locale/fr";
moment.locale("fr");

export default {
  props: ["controller"],

  data() {
    return {
      selectedElementToUpdate: null,
      blockingType: null,

      colSai: "",
      uvcSai: "",
      netSai: "",

      dialog: false,

      errorNotif: false,
      errorMessage: "",
      successNotif: false,
      successMessage: "",
      snackbarColor: "success"
    };
  },

  computed: {
    canValidateVl: function() {
      if (this.colSai === "" || this.uvcSai === "" || this.netSai === "") {
        return true;
      } else return false;
    },
    ModalTitle: {
      // getter
      get: function() {
        let title = "";
        switch (this.blockingType) {
          case "B":
            title = "Blocage";
            break;
          case "D":
            title = "Déblocage";
            break;
          default:
            title = `No title`;
        }
        return `${title}`;
      }
    }
  },

  methods: {
    /**
     * call Api to lock or unlock vl
     */
    async validate_VL() {
      let self = this;
      try {
        let sendResult = await self.controller.LogisticVariantStore.postBlockUnblocklogisticVariant(
          this.selectedElementToUpdate.id,
          this.blockingType,
          this.colSai,
          this.uvcSai,
          this.netSai
        );

        if (sendResult.status >= 400 && sendResult.status < 500) {
          if (sendResult.data) {
            let listError = sendResult.data;
            if (sendResult.data.errors) {
              listError = sendResult.data.errors;
            }

            let errorMessage = "";
            Object.entries(listError).forEach(function([, valeur]) {
              errorMessage += `${valeur}\n`;
            });
            this.errorMessage = errorMessage;
            this.errorNotif = true;
          }
        } else {
          this.successMessage = `${this.ModalTitle} effectué`;
          this.successNotif = true;
          this.controller.EventBus.$emit("refreshList");
          this.dialog = false;
        }
      } catch (error) {
        //Log
        self.controller.Log.LogError(`formLogisticVariantLockComponent`, error);
        self.hasRows = false;
      }
    },

    /**
     * Get logisticVariant to update
     */
    async loadLogisticVariant(blockingType, selectedElement) {
      this.blockingType = blockingType;
      //init input when open windows
      this.colSai = "";
      this.uvcSai = "";
      this.netSai = "";

      //Récupérer les infos de la VL
      this.selectedElementToUpdate = await this.controller.LogisticVariantStore.getlogisticVariant(selectedElement.id);

      this.dialog = true;
    },

    /**
     * Close dialog box
     */
    cancel() {
      this.dialog = false;
    },

    /**
     * Calculate UVC and Net weight for lock/unlock
     */
    async calculateValue() {
      let lvTemp = await this.controller.LogisticVariantStore.getCalculateUVCAndNetWeight(this.selectedElementToUpdate.id, this.colSai);
      this.uvcSai = lvTemp.data.csuNumber;
      this.netSai = lvTemp.data.netWeight;
    }
  },

  async beforeMount() {
    this.controller.EventBus.$on("showModal", await this.loadLogisticVariant);
  },

  async beforeDestroy() {
    this.controller.EventBus.$off("showModal", await this.loadLogisticVariant);
  }
};
</script>
